import { __decorate, __metadata, __param } from "tslib";
import { __inject, inject } from '@studio/utils/di';
let AdApi = class AdApi {
    constructor(ad, _env) {
        this.ad = ad;
        this.parameters = ad.parameters;
        this.customDomain = _env.CUSTOM_AD_DOMAIN;
    }
    trackCustomEvent(eventData) {
        this.ad.tracking.trackCustomEvent(eventData);
    }
    trackCustomProgressEvent(eventData) {
        if (eventData.value < 0 && eventData.value > 1) {
            throw new Error('Event value for custom progess events has to be between 0 and 1');
        }
        this.ad.tracking.trackCustomProgressEvent(eventData);
    }
};
AdApi = __decorate([
    __param(0, inject(0 /* T.AD */)),
    __param(1, inject(2 /* T.ENVIRONMENT */)),
    __metadata("design:paramtypes", [Object, Object])
], AdApi);
export { AdApi };
__inject(0 /* T.AD */, {}, AdApi, '_ad', 0);
__inject(2 /* T.ENVIRONMENT */, {}, AdApi, '_env', 1);
